// extracted by mini-css-extract-plugin
module.exports = {"grid":"RpMainGrid_grid__1EKFK","grid_title":"RpMainGrid_grid_title__Ne2iJ"};